/* mutation must be Synchronous */
export default {
  increment (state, payLoad) {
    /* typeof payLoad is object */
    state.count += payLoad.amount
  },
  userInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  activityInfo (state, activityInfo) {
    state.activityInfo = activityInfo
  },
  productList: (state, productList) => {
    state.productList = productList
  },
  applyGiftMaterialList: (state, applyGiftMaterialList) => {
    state.applyGiftMaterialList = applyGiftMaterialList
  },
  contentVenderLabelList: (state, contentVenderLabel) => {
    state.contentVenderLabelList = contentVenderLabel
  },
  couponList: (state, couponList) => {
    state.couponList = couponList
  },
  promotionList: (state, promotionList) => {
    state.promotionList = promotionList
  },
  beltList: (state, beltList) => {
    state.beltList = beltList
  },
  setLangFlag: (state) => {
    state.langFlag++
  },
  setApplyId: (state, applyId) => {
    state.applyId = applyId
  },
  setMarketSearchObj: (state, proload) => {
    Object.assign(state.marketSearchObj, proload)
  },
  setActivitySearchObj: (state, proload) => {
    Object.assign(state.activitySearchObj, proload)
  },
  setInviteShopList: (state, proload) => {
    state.inviteShopList = proload
  },
  delInviteShopList: (state, proload) => {
    let arr = []
    state.inviteShopList.forEach(item => {
      if (proload.inviteeId !== item.inviteeId) {
        arr.push(item)
      }
    })
    state.inviteShopList = arr
  }
}



// WEBPACK FOOTER //
// ./src/store/mutation.js